import { createRouter, createWebHistory } from 'vue-router'
import TopPageView from '@/views/TopPageView.vue'
import Store from '@/store/index.js'
import { bl, paths, } from '@/common/const'
const routes = [
  // TOPページ
  {
    path: paths.top,
    name: 'top-page',
    component: TopPageView,
    meta: {
      requiresAuth: true,
      bl: bl.nothing,
    },
  },
  // 企業情報詳細
  {
    path: paths.company,
    name: "company",
    component: () => import('@/views/company/CompanyDetailView.vue'),
    meta: {
      requiresAuth: true,
      bl: bl.nothing,
    },
  },
  // 企業情報更新
  {
    path: paths.companyChange,
    name: "companyChange",
    component: () => import('@/views/company/CompanyChangeInfoView.vue'),
    meta: {
      requiresAuth: true,
      bl: bl.user,
    },
  },
  // 回線情報一覧
  {
    path: paths.line,
    name: 'line-info-list',
    component: () => import('@/views/line/LineInfoListView.vue'),
    meta: { 
      requiresAuth: true,
      bl: bl.nothing,
    },
  },
  // 回線詳細
  {
    path: paths.lineDetail,
    name: "line-detail",
    component: () => import('@/views/line/LineInfoDetailView.vue'),
    meta: { 
      requiresAuth: true,
      bl: bl.nothing,
    },
  },
  // 回線解約
  {
    path: paths.lineCancel,
    name: "line-cancel",
    component: () => import('@/views/line/LineCancelView.vue'),
    meta: { 
      requiresAuth: true,
      bl: bl.nothing,
    },
  },
  // オプション追加
  {
    path: paths.optinonAdd,
    name: "option-add",
    component: () => import('@/views/line/LineOptionAddView.vue'),
    meta: { 
      requiresAuth: true,
      bl: bl.nothing,
    },
  },
  // オプション解約
  {
    path: paths.optinonCancel,
    name: "option-cancel",
    component: () => import('@/views/line/LineOptionCancelView.vue'),
    meta: { 
      requiresAuth: true,
      bl: bl.nothing,
    },
  },
  // ご利用金額
  {
    path: paths.usage,
    name: "usage",
    component: () => import('@/views/usageFee/UsageFeeView.vue'),
    meta: {
      requiresAuth: true,
      bl: bl.nothing,
    },
  },
  // ご利用明細
  {
    path: paths.usageDetail,
    name: "usageDetail",
    component: () => import('@/views/usageFee/UsageFeeDetailView.vue'),
    meta: {
      requiresAuth: true,
      bl: bl.nothing,
    },
  },
    // 担当者情報
  {
    path: paths.employee,
    name: 'employee-list',
    component: () => import('@/views/employee/EmployeeListView.vue'),
    meta: {
      requiresAuth: true,
      bl: bl.user,
    }
  },
  {
    path: paths.employeeAdd,
    name: 'employee-add',
    component: () => import('@/views/employee/EmployeeAddView.vue'),
    meta: {
      requiresAuth: true,
      bl: bl.user,
    },
  },
  {
    path: paths.employeeUpdate,
    name: 'employee-update',
    component: () => import('@/views/employee/EmployeeUpdateView.vue'),
    meta: {
      requiresAuth: true,
      bl: bl.user,
    },
  },
  // ログインページ
  {
    path: paths.login,
    name: 'login',
    component: () => import('@/views/login/LoginView.vue'),
    meta: {
      requiresAuth: false,
      bl: bl.nothing,
    },
  },
  // ログインアカウント
  {
    path: paths.account,
    name: 'account',
    component: () => import('@/views/account/AccountInfoView.vue'),
    meta: {
      requiresAuth: true,
      bl: bl.nothing
    }
  },
  // パスワード変更
  {
    path: paths.passwordUpdate,
    name: 'password-update',
    component: () => import('@/views/account/PasswordUpdateView.vue'),
    meta: {
      requiresAuth: true,
      bl: bl.nothing,
    },
  },
  // パスワード初期化メール送信
  {
    path: paths.passwordSendMail,
    name: 'passwordSendMail',
    component: () => import('@/views/password/PasswordSendMailView.vue'),
    meta: {
      requiresAuth: false,
      bl: bl.nothing,
    },
  },
  // パスワード初期化実行
  {
    path: paths.resetPassword,
    name: 'resetPassword',
    component: () => import('@/views/password/PasswordResetView.vue'),
    meta: {
      requiresAuth: false,
      bl: bl.nothing,
    },
  },
  // システムエラー画面
  {
    path: paths.error,
    name: 'systenError',
    component: () => import('@/views/error/SystemErrorView.vue'),
    meta: { 
      requiresAuth: true, 
      bl: bl.nothing,
    },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior(to,from,savePosition){
    if(savePosition){
      return {savePosition}
    }
    if(to.hash){
      return {el: to.hash}
    }
    return {top : 0}
  },
  routes
})

router.beforeEach((to, from, next) => {
  // 認証が必要かどうか
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!Store.state.token || Store.state.loginUser.accountLockFlg === '1') {
      next({ path: '/login', query: { redirect: to.fullPath } });
      // 権限チェック
    } else if (to.matched.some(record => record.meta.bl.includes(Store.state.loginUser.userRole))) {
      // Topページ
      next(paths.top);
    } else if ((Store.state.loginUser.firstPwdChngFlg === '1' || Store.state.loginUser.pwdExpiredFlg === '1') && to.path != paths.passwordUpdate)  {
      next(paths.passwordUpdate);
    } else {
      next();
    }
  } else {
    next();
  }

});

export default router